import { useAppContext } from 'contexts/app-context/hooks'
import { useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'

export function useHelpCenterBottomSheet() {
  const { privacyCenterContent } = useAppContext()
  const navigate = useNavigate()

  const onError = () => navigate(Routes.ERROR)

  const isActive = privacyCenterContent?.components.needHelpBottomShet?.isActive
  const content = privacyCenterContent?.components.needHelpBottomShet?.content

  return {
    isActive,
    content,
    onError,
    navigateTo: (route: string) => {
      navigate(route)
    },
  }
}
